import { takeEvery, takeLatest } from 'redux-saga/effects';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import {
  ANNULMENT_CARRIER,
  ANNULMENT_SZLT,
  ANNULMENT_VEHICLES,
  ARCHIVE_CARRIER,
  ARCHIVE_SZLT,
  ARCHIVE_VEHICLES,
  ASSIGN_SZLT_BY_ID,
  CARRIER_HELPER,
  CREATE_CARRIER,
  CREATE_CARRIER_STATEMENT,
  CREATE_SZLT,
  CREATE_SZLT_STATEMENT,
  CREATE_VEHICLES,
  CREATE_VEHICLES_STATEMENT,
  DELETE_CARRIER,
  DELETE_SZLT,
  DELETE_VEHICLES,
  EDIT_CARRIER_BY_ID,
  EDIT_SZLT_BY_ID,
  EDIT_VEHICLES_BY_ID,
  EXPORT_CARRIER,
  EXPORT_SZLT,
  EXPORT_VEHICLES,
  IMPORT_CARRIER,
  IMPORT_SZLT,
  IMPORT_VEHICLES,
  LOAD_CARRIER_BY_ID,
  LOAD_CARRIER_LIST,
  LOAD_REGISTRY_EXPORT_LIST,
  LOAD_REGISTRY_HISTORY_LIST,
  LOAD_REGISTRY_SMEV_CHECK_LIST,
  LOAD_SMEV_CHECK_CARRIER_LIST,
  LOAD_SMEV_CHECK_SZLT_LIST,
  LOAD_SMEV_CHECK_VEHICLE_LIST,
  LOAD_SZLT_BY_ID,
  LOAD_SZLT_LIST,
  LOAD_VEHICLES_BY_ID,
  LOAD_VEHICLES_LIST,
  RESUMED_CARRIER,
  RESUMED_SZLT,
  SMEV_CHECK_ALL_CARRIER,
  SMEV_CHECK_ALL_SZLT,
  SMEV_CHECK_ALL_VEHICLES,
  INACTIVE_CARRIER,
  INACTIVE_SZLT,
  SZLT_HELPER,
  UNARCHIVE_CARRIER,
  UNARCHIVE_SZLT,
  UNARCHIVE_VEHICLES,
  VEHICLES_HELPER,
  SEND_CARRIER_FGIS_TAXI,
  SEND_VEHICLES_FGIS_TAXI,
  SEND_SZLT_FGIS_TAXI,
  EXTRACT_SZLT,
  EXTRACT_VEHICLES,
  EXTRACT_CARRIER,
  CARRIER_FIELDS_VALIDATION,
  VEHICLE_FIELDS_VALIDATION,
  SZLT_FIELDS_VALIDATION,
  LOAD_RELATION_CARRIER_SZLT_LIST,
  LOAD_RELATION_CARRIER_VEHICLE_LIST,
  LOAD_RELATION_VEHICLE_SZLT_LIST,
  IMPORT_CARRIER_VEHICLE,
  LOAD_STATUS_IMPORT,
  LOAD_CARRIER_LIST_MODAL,
  LOAD_SZLT_LIST_MODAL,
  LOAD_VEHICLES_LIST_MODAL,
  EXPORT_OSAGO,
  IMPORT_OSAGO,
  RESTORE_VEHICLES,
  RESTORE_SZLT,
  RESTORE_CARRIER, LOAD_SZLT_LIST_ID, LOAD_CARRIER_LIST_ID, LOAD_VEHICLE_LIST_ID, BATCH_COMMAND_VEHICLE,
  BATCH_COMMAND_CARRIER, BATCH_COMMAND_SZLT,
} from '../actions';

import loadSZLTList from './loadSZLTList';
import createSZLT from './createSZLT';
import loadSZLTById from './loadSZLTById';
import assignSZLTById from './assignSZLTById';
import editSZLTById from './editSZLTById';
import archiveSZLT from './archiveSZLT';
import unarchiveSZLT from './unarchiveSZLT';
import deleteSZLT from './deleteSZLT';
import annulmentSZLT from './annulmentSZLT';
import loadCarrierList from './loadCarrierList';
import createCarrier from './createCarrier';
import loadCarrierById from './loadCarrierById';
import editCarrierById from './editCarrierById';
import deleteCarrier from './deleteCarrier';
import loadVehiclesList from './loadVehiclesList';
import createVehicles from './createVehicles';
import loadVehiclesById from './loadVehiclesById';
import editVehiclesById from './editVehiclesById';
import deleteVehicles from './deleteVehicles';
import vehiclesHelper from './vehiclesHelper';
import szltHelper from './szltHelper';
import carrierHelper from './carrierHelper';
import loadRegistryHistoryList from './loadRegistryHistoryList';
import loadRegistryExportList from './loadRegistryExportList';
import loadRegistrySmevCheckList from './loadRegistrySmevCheckList';
import importCarrier from './importCarrier';
import importSZLT from './importSZLT';
import importVehicles from './importVehicles';
import exportCarrier from './exportCarrier';
import exportSZLT from './exportSZLT';
import exportVehicles from './exportVehicles';
import loadSmevCheckVehicleList from './loadSmevCheckVehicleList';
import loadSmevCheckSZLTList from './loadSmevCheckSZLTList';
import loadSmevCheckCarrierList from './loadSmevCheckCarrierList';
import smevCheckAllCarrier from './smevCheckAllCarrier';
import smevCheckAllSZLT from './smevCheckAllSZLT';
import smevCheckAllVehicles from './smevCheckAllVehicles';
import unarchiveCarrier from './unarchiveCarrier';
import unarchiveVehicles from './unarchiveVehicles';
import archiveCarrier from './archiveCarrier';
import archiveVehicles from './archiveVehicles';
import annulmentVehicles from './annulmentVehicles';
import annulmentCarrier from './annulmentCarrier';
import resumedCarrier from './resumedCarrier';
import resumedSZLT from './resumedSZLT';
import inactiveSZLT from './inactiveSZLT';
import createCarrierStatement from './createCarrierStatement';
import createSZLTStatement from './createSZLTStatement';
import createVehiclesStatement from './createVehiclesStatement';
import inactiveCarrier from './inactiveCarrier';
import sendSzltFgisTaxi from './sendSzltFgisTaxi';
import sendVehiclesFgisTaxi from './sendVehiclesFgisTaxi';
import sendCarrierFgisTaxi from './sendCarrierFgisTaxi';
import extractVehiciesById from './extractVehiciesById';
import extractCarrierById from './extractCarrierById';
import extractSZLTById from './extractSZLTById';
import loadCarrierFieldsValidation from './loadCarrierFieldsValidation';
import loadSZLTFieldsValidation from './loadSZLTFieldsValidation';
import loadVehicleFieldsValidation from './loadVehicleFieldsValidation';
import loadRelationCarrierSzltList from './loadRelationCarrierSzltList';
import loadRelationCarrierVehicleList from './loadRelationCarrierVehicleList';
import loadRelationVehicleSzltList from './loadRelationVehicleSzltList';
import importCarrierWithVehicle from './importCarrierWithVehicle';
import checkImportStatus from './checkImportStatus';
import loadSZLTListModal from './loadSZLTListModal';
import loadCarrierListModal from './loadCarrierListModal';
import loadVehiclesListModal from './loadVehiclesListModal';
import exportOsago from './exportOsago';
import importOsago from './importOsago';
import restoreSZLT from './restoreSZLT';
import restoreCarrier from './restoreCarrier';
import restoreVehicle from './restoreVehicle';
import loadSzltIdList from './loadSzltIdList';
import loadCarrierIdList from './loadCarrierIdList';
import loadVehicleIdList from './loadVehicleIdList';
import carrierRegistryBatchCommand from './carrierRegistryBatchCommand';
import vehicleRegistryBatchCommand from './vehicleRegistryBatchCommand';
import szltRegistryBatchCommand from './szltRegistryBatchCommand';

export default function* watchDashboard() {
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST, loadRelationCarrierSzltList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST, loadRelationCarrierVehicleList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST, loadRelationVehicleSzltList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL, loadCarrierListModal);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL, loadSZLTListModal);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL, loadVehiclesListModal);
  yield takeLatest(REGION_REGISTRY_MODULE + EXPORT_OSAGO, exportOsago);
  yield takeLatest(REGION_REGISTRY_MODULE + IMPORT_OSAGO, importOsago);
  yield takeEvery(REGION_REGISTRY_MODULE + RESTORE_VEHICLES, restoreVehicle);
  yield takeEvery(REGION_REGISTRY_MODULE + RESTORE_SZLT, restoreSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + RESTORE_CARRIER, restoreCarrier);

  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST, loadSZLTList);
  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_SZLT, createSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID, loadSZLTById);
  yield takeEvery(REGION_REGISTRY_MODULE + ASSIGN_SZLT_BY_ID, assignSZLTById);
  yield takeEvery(REGION_REGISTRY_MODULE + EDIT_SZLT_BY_ID, editSZLTById);
  yield takeEvery(REGION_REGISTRY_MODULE + ARCHIVE_SZLT, archiveSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + UNARCHIVE_SZLT, unarchiveSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + DELETE_SZLT, deleteSZLT);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST, loadCarrierList);
  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_CARRIER, createCarrier);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID, loadCarrierById);
  yield takeEvery(REGION_REGISTRY_MODULE + EDIT_CARRIER_BY_ID, editCarrierById);
  yield takeEvery(REGION_REGISTRY_MODULE + DELETE_CARRIER, deleteCarrier);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST, loadVehiclesList);
  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_VEHICLES, createVehicles);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID, loadVehiclesById);
  yield takeEvery(REGION_REGISTRY_MODULE + EDIT_VEHICLES_BY_ID, editVehiclesById);
  yield takeEvery(REGION_REGISTRY_MODULE + DELETE_VEHICLES, deleteVehicles);
  yield takeEvery(REGION_REGISTRY_MODULE + VEHICLES_HELPER, vehiclesHelper); // специально не LATEST. Несколько хелперов на странице
  yield takeEvery(REGION_REGISTRY_MODULE + CARRIER_HELPER, carrierHelper); // специально не LATEST. Несколько хелперов на странице
  yield takeEvery(REGION_REGISTRY_MODULE + SZLT_HELPER, szltHelper); // специально не LATEST. Несколько хелперов на странице
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST, loadRegistryHistoryList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST, loadRegistryExportList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST, loadRegistrySmevCheckList);

  yield takeLatest(REGION_REGISTRY_MODULE + IMPORT_CARRIER, importCarrier);
  yield takeLatest(REGION_REGISTRY_MODULE + IMPORT_VEHICLES, importVehicles);
  yield takeLatest(REGION_REGISTRY_MODULE + IMPORT_SZLT, importSZLT);
  yield takeLatest(REGION_REGISTRY_MODULE + IMPORT_CARRIER_VEHICLE, importCarrierWithVehicle);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT, checkImportStatus);
  yield takeLatest(REGION_REGISTRY_MODULE + EXPORT_CARRIER, exportCarrier);
  yield takeLatest(REGION_REGISTRY_MODULE + EXPORT_VEHICLES, exportVehicles);
  yield takeLatest(REGION_REGISTRY_MODULE + EXPORT_SZLT, exportSZLT);

  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_VEHICLE_LIST, loadSmevCheckVehicleList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_SZLT_LIST, loadSmevCheckSZLTList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_CARRIER_LIST, loadSmevCheckCarrierList);

  yield takeLatest(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_CARRIER, smevCheckAllCarrier);
  yield takeLatest(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_SZLT, smevCheckAllSZLT);
  yield takeLatest(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_VEHICLES, smevCheckAllVehicles);

  yield takeEvery(REGION_REGISTRY_MODULE + ARCHIVE_CARRIER, archiveCarrier);
  yield takeEvery(REGION_REGISTRY_MODULE + UNARCHIVE_CARRIER, unarchiveCarrier);

  yield takeEvery(REGION_REGISTRY_MODULE + ARCHIVE_VEHICLES, archiveVehicles);
  yield takeEvery(REGION_REGISTRY_MODULE + UNARCHIVE_VEHICLES, unarchiveVehicles);

  yield takeEvery(REGION_REGISTRY_MODULE + ANNULMENT_SZLT, annulmentSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + ANNULMENT_VEHICLES, annulmentVehicles);
  yield takeEvery(REGION_REGISTRY_MODULE + ANNULMENT_CARRIER, annulmentCarrier);

  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_CARRIER_STATEMENT, createCarrierStatement);
  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_VEHICLES_STATEMENT, createVehiclesStatement);
  yield takeEvery(REGION_REGISTRY_MODULE + CREATE_SZLT_STATEMENT, createSZLTStatement);

  yield takeEvery(REGION_REGISTRY_MODULE + INACTIVE_CARRIER, inactiveCarrier);
  yield takeEvery(REGION_REGISTRY_MODULE + INACTIVE_SZLT, inactiveSZLT);
  yield takeEvery(REGION_REGISTRY_MODULE + RESUMED_CARRIER, resumedCarrier);
  yield takeEvery(REGION_REGISTRY_MODULE + RESUMED_SZLT, resumedSZLT);

  yield takeEvery(REGION_REGISTRY_MODULE + SEND_CARRIER_FGIS_TAXI, sendCarrierFgisTaxi);
  yield takeEvery(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI, sendVehiclesFgisTaxi);
  yield takeEvery(REGION_REGISTRY_MODULE + SEND_SZLT_FGIS_TAXI, sendSzltFgisTaxi);

  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_SZLT, extractSZLTById);
  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES, extractVehiciesById);
  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_CARRIER, extractCarrierById);

  yield takeEvery(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION, loadCarrierFieldsValidation);
  yield takeEvery(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION, loadSZLTFieldsValidation);
  yield takeEvery(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION, loadVehicleFieldsValidation);

  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_ID, loadSzltIdList);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_ID, loadCarrierIdList);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_VEHICLE_LIST_ID, loadVehicleIdList);

  yield takeEvery(REGION_REGISTRY_MODULE + BATCH_COMMAND_VEHICLE, vehicleRegistryBatchCommand);
  yield takeEvery(REGION_REGISTRY_MODULE + BATCH_COMMAND_SZLT, szltRegistryBatchCommand);
  yield takeEvery(REGION_REGISTRY_MODULE + BATCH_COMMAND_CARRIER, carrierRegistryBatchCommand);
}
